export const reportsEn = {
  REPORTS: 'Reports',
  DOWNLOAD_REPORT: 'Download Report',
  RECEIVABLES_AGING: 'Receivables Aging',
  FEES: 'Fees',
  AVAILABLE_FOR_RELEASE: 'Available for Release',
  //STAR MICHAEL
  SALES_COMMISSION_REPORT: 'Sales Commission Report',
  SELECT_FILTER_VIEW_RECORD: 'Select the filters to view the record',
  SELECT_DATE_AND_SALES_EXECUTIVE_FILTER:
    'To display results, choose a date range and select at least one sales executive.',
  SELECT_DATE_VIEW_RECORD: 'To display results, choose a date range.',
  AGING_BY_DEBTOR_REPORT: 'Aging By Debtor Report',
  NO_DATA_SELECT_FILTERS_AGING_REPORT:
    'If you do not see data, please select the end date up to which you wish to retrieve the information. This date is required to generate the corresponding reports.',
  CLIENTS_PER_PAGE: 'Clients per page',
  DEBTORS_PER_PAGE: 'Debtors per page',
  AGED_0_TO_30: '0-30 Aged',
  AGED_31_TO_60: '31-60 Aged',
  AGED_61_TO_90: '61-90 Aged',
  AGED_91_TO_120: '91-120 Aged',
  AGED_120_PLUS: '120+ Aged',
  CLIENT_TOTALS: 'Client Totals',
  EMAILS_TO_SEND_REPORT: 'Emails to send report',
  EMAIL_LENGHT_MUST_BE_LESS_EQUALS_50: 'Email length must be less than or equal to 50 characters',
  EMAIL_ALREADY_EXISTS_ON_LIST: 'Email already exists on the list',
  //END MICHAEL

  //STAR FABIAN
  SETTLEMENT_DATE_VIEW_RECORDS: 'To display results, choose a date range and select a filter type.',
  AS_OF_DATE: 'As of date',
  FILTER_TYPE: 'Filter type',
  SETTLEMENT_REPORT: 'Settlement Report',
  ERROR_GET_SETTLEMENT_REPORT: 'It is not possible to obtain the report information. Please try again later.',
  PAID_ON_DATE: 'Payment Date',
  CLIENT_SUMMARY_DATE_VIEW_RECORDS: 'To display results, choose a date range',
  STARTING_AR_BALANCE: 'Starting AR Balance',
  ENDING_AR_BALANCE: 'Ending AR Balance',
  FUNDED_AR: 'Funded AR',
  OOS_INVOICES: 'OOS Invoices',
  NF_INVOICES: 'NF Invoices',
  COLLECTED_AR: 'Collected AR',
  NF_COLLECTED: 'NF Collected',
  OOS_COLLECTED: 'OOS Collected',
  OVERPAYMENTS: 'Overpayments',
  TOTAL_COLLECTED: 'Total Collected',
  CLIENT_SUMMARY: 'Client Summary',
  AR_CHANGES: 'AR Changes',
  //END FABIAN

  CASH_RESERVE_BALANCE: 'Cash Reserve Balance',
  ESCROW_RESERVE_BALANCE: 'Escrow Reserve Balance',
  TOTAL_RESERVES: 'Total Reserves',
  ESCROW_RESERVES: 'Escrow Reserves',
  INELIGIBLE_DISPUTED: 'Ineligible/Disputed',
  ACCRUED_FEES: 'Accrued Fees',
  ACCRUED_INTEREST: 'Accrued Interest',
}

export const reportsEs: typeof reportsEn = {
  REPORTS: 'Informes',
  DOWNLOAD_REPORT: 'Descargar Informe',
  RECEIVABLES_AGING: 'Antigüedad de los créditos',
  FEES: 'Tarifas',
  AVAILABLE_FOR_RELEASE: 'Disponible para liberar',
  //STAR MICHAEL
  SALES_COMMISSION_REPORT: 'Informe de comisiones de ventas',
  SELECT_FILTER_VIEW_RECORD: 'Seleccione los filtros para ver el registro',
  SELECT_DATE_AND_SALES_EXECUTIVE_FILTER:
    'Para mostrar resultados, elija un rango de fechas y seleccione al menos un ejecutivo de ventas.',
  SELECT_DATE_VIEW_RECORD: 'Para mostrar resultados, elija un rango de fechas.',
  AGING_BY_DEBTOR_REPORT: 'Informe de antigüedad por deudor',
  NO_DATA_SELECT_FILTERS_AGING_REPORT:
    'Si no ve datos, seleccione la fecha de finalización hasta la cual desea recuperar la información. Esta fecha es necesaria para generar los reportes correspondientes.',
  CLIENTS_PER_PAGE: 'Clientes por página',
  DEBTORS_PER_PAGE: 'Deudores por página',
  AGED_0_TO_30: '0-30 Días',
  AGED_31_TO_60: '31-60 Días',
  AGED_61_TO_90: '61-90 Días',
  AGED_91_TO_120: '91-120 Días',
  AGED_120_PLUS: '120+ Días',
  CLIENT_TOTALS: 'Totales del cliente',
  EMAILS_TO_SEND_REPORT: 'Correos electrónicos para enviar informe',
  EMAIL_LENGHT_MUST_BE_LESS_EQUALS_50: 'La longitud del correo electrónico debe ser menor o igual a 50 caracteres',
  EMAIL_ALREADY_EXISTS_ON_LIST: 'El correo electrónico ya existe en la lista',
  //END MICHAEL

  //STAR FABIAN
  SETTLEMENT_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija un rango de fechas y seleccione un tipo de filtro.',
  AS_OF_DATE: 'A la fecha',
  FILTER_TYPE: 'Tipo de filtro',
  SETTLEMENT_REPORT: 'Informe de liquidación',
  ERROR_GET_SETTLEMENT_REPORT:
    'No es posible obtener la información del informe. Por favor, inténtelo de nuevo más tarde.',
  PAID_ON_DATE: 'Fecha de Pago',
  CLIENT_SUMMARY_DATE_VIEW_RECORDS: 'Para mostrar resultados, elija un rango de fechas',
  STARTING_AR_BALANCE: 'Saldo inicial de AR',
  ENDING_AR_BALANCE: 'Saldo final de AR',
  FUNDED_AR: 'AR financiado',
  OOS_INVOICES: 'Facturas OOS',
  NF_INVOICES: 'Facturas NF',
  COLLECTED_AR: 'AR cobrado',
  NF_COLLECTED: 'Cobrado NF',
  OOS_COLLECTED: 'Cobrado OOS',
  OVERPAYMENTS: 'Sobrepagos',
  TOTAL_COLLECTED: 'Total cobrado',
  CLIENT_SUMMARY: 'Resumen del cliente',
  AR_CHANGES: 'Cambios en AR',
  //END FABIAN

  CASH_RESERVE_BALANCE: 'Saldo de reserva en efectivo',
  ESCROW_RESERVE_BALANCE: 'Saldo de reserva en fideicomiso',
  TOTAL_RESERVES: 'Reservas totales',
  ESCROW_RESERVES: 'Reservas en fideicomiso',
  INELIGIBLE_DISPUTED: 'No elegible / En disputa',
  ACCRUED_FEES: 'Honorarios devengados',
  ACCRUED_INTEREST: 'Intereses devengados',
}
